<template>
  <div>
    <div class="header-holder"></div>

    <div class="product-list-header" :class="'logo'">
      <div class="slot" v-if='config'>
        <img v-if="from == 'home'" :src='config.site_mobile_logo'>
        <div v-else style="text-align: left">
          <span class="iconfont" @click="$router.go(-1)">&#xe67f;</span>
        </div>
      </div>
      <div class="common-search">
        <input v-if="from == 'search'" type="text" :placeholder="$t('EnterSearchContent')" v-model="keyword"
          @keyup.enter="goSearch(keyword)">
        <input v-else-if="from == 'store'" type="text" :placeholder="$t('EnterSearchContent')" v-model="keyword"
          @keyup.enter="goStoreGoods(keyword)">
        <input v-else type="text" :placeholder="$t('EnterSearchContent')" readonly="true" autocomplete="off"
          v-model="keyword" @click="onSearch">
      </div>
      <!-- <div class="right iconfont popup-menu-area" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></div> -->
      <header-more v-show="popupVisible" :showDot="showDot"></header-more>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapState } from 'vuex'
import { getChatCount } from '../../../api/memberInstantMessage'
import HeaderMore from '../../HeaderMore'
export default {
  name: 'HomeCommonSearch',
  components: {
    HeaderMore
  },
  props: ['value', 'from'],
  watch: {
    value: function (value) {
      if (value) {
        this.keyword = value
      }
    }
  },
  mounted: function () {
    document.addEventListener('click', (e) => {
      let thisClassName = e.target.className
      if (thisClassName != 'right iconfont popup-menu-area') {
        this.popupVisible = false
      }
    })
    document.addEventListener('touchmove', (e) => {
      this.popupVisible = false
    })
  },
  data() {
    return {
      keyword: this.value ? this.value : '', // 关键字
      currenKeywords: this.utils.fetch('keyword'),
      popupVisible: false,
      showDot: false
    }
  },
  created: function () {
    if (this.isOnline) {
      getChatCount().then(res => {
        if (res.result) {
          if (!this.showDot) {
            this.showDot = {}
          }
          this.showDot['chat'] = true
        }
      })
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      isOnline: state => state.member.isOnline
    })
  },
  methods: {
    onSearch() {
      this.$router.push({ name: 'HomeSearch', params: { isFromHome: true } })
    },
    goStoreGoods() {
      this.$router.push({
        name: 'HomeStoreGoodslist',
        query: { id: this.$route.query.id, keywords: this.keyword }
      })
    },
    goSearch(value) {
      if (value.replace(/\s+/g, '').length <= 0) {
        Toast('Please enter your search')
        return false
      } else {
        this.keywords = value
      }
      if (value) {
        this.currenKeywords.push(value)
        let data = this.utils.arrayFilter(this.currenKeywords)
        this.utils.save('keyword', data)
      }
      this.$router.push({
        name: 'HomeGoodslist',
        query: { keywords: this.keywords }
      })
    },
    popupMore() {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dot {
  position: absolute;
  width: .5rem;
  height: .5rem;
  background: red;
  border-radius: 50%;
  top: .2rem;
  right: 0;
}

.product-list-header.logo {
  .slot {
    width: 1rem;
    text-align: center;
    line-height: 1.6rem;
    font-size: 24px;
    color: #1C0839;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .common-search {
    padding: 0;
    padding-left: $pageSpace;
    padding-right: $pageSpace;
  }
}

.header-holder {
  height: $headerHeight;
}

.product-list-header {
  display: flex;
  height: $headerHeight;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: $pageSpace;
  padding-right: $pageSpace;
  padding: $pageSpace;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 4px #f7f7f7;
  background: #fff;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
  box-sizing: border-box;

  .slot {
    width: 1.6rem;
    font-size: $h2
  }
}

.common-search {
  flex: 1;
  padding: 0.35rem 0.3rem 0.35rem 0;
}

.common-search input {
  box-sizing: border-box;
  width: 100%;
  height: 1.6rem;
  border-radius: 1.6rem;
  background: #F4F4F4 url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
  background-size: 0.55rem;
  font-size: $fontSize;
  color: #999;
  padding-left: 1.6rem;
  border: 0;
}

.right {
  width: 1.6rem;
  height: 1.6rem;
  text-align: center;
  line-height: 1.6rem;
  position: relative
}
</style>
